import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Login } from 'react-cognito';
import { setRuntimeVariable } from '../../actions/runtime';
import Button from '../Button';
import { Form, Input } from '../Form';
import Link from '../Link';
import { Brandmark } from '../Icons';
import { H3, L2, P1, P2 } from '../Typography';
import Style from '../Style';

class LoginForm extends React.PureComponent {
  static propTypes = {
    email: PropTypes.string,
    error: PropTypes.string,
    onSubmit: PropTypes.func,
    onGoToRegister: PropTypes.func,
    onForgotPassword: PropTypes.func,
    onAfterLogin: PropTypes.func,
  };
  static defaultProps = {
    onAfterLogin: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      fetching: false,
      formEnabled: true,

      email: '',
      password: '',
      error: '',
    };
  }

  onSubmit = () => {
    if (!this.state.formEnabled) {
      return;
    }

    this.setState({ fetching: true, formEnabled: false, error: '' });
    this.props
      .onSubmit(this.state.email.toLowerCase(), this.state.password)
      .then(() => this.props.onAfterLogin())
      .then(() => this.setState({ fetching: false }))
      .catch(error =>
        this.setState({
          fetching: false,
          formEnabled: true,
          error: error.message,
        }),
      );
  };

  render() {
    const {
      email,
      error,
      onSubmit,
      onGoToRegister,
      onForgotPassword,
      onAfterLogin,
      ...otherProps
    } = this.props;

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '5rem 6rem',
        }}
      >
        <div>
          <Brandmark />
        </div>
        <H3 style={{ marginTop: '3rem' }}>Sign In</H3>
        <P1 style={{ color: Style.Colors.shadow3 }}>
          Don't have an account yet?{' '}
          <Link underline={true} onClick={onGoToRegister}>
            Sign up
          </Link>
        </P1>

        <Form onSubmit={this.onSubmit} enabled={this.state.formEnabled}>
          <Input
            name="email"
            type="email"
            value={this.state.email}
            onChange={value => this.setState({ email: value })}
          >
            YOUR EMAIL
          </Input>
          <Input
            name="password"
            type="password"
            value={this.state.password}
            onChange={value => this.setState({ password: value })}
            // onPaste={value => setTimeout(this.setState, 0, { password: value }}
          >
            AND PASSWORD
          </Input>
        </Form>

        <div
          style={{
            width: '100%',
            textAlign: 'left',
            color: Style.Colors.error,
          }}
        >
          <P1>{this.state.error || error || <span>&nbsp;</span>}</P1>
        </div>

        <P1
          style={{
            marginTop: '1.5rem',
          }}
        >
          Forgot your password?{' '}
          <Link underline={true} onClick={onForgotPassword}>
            Reset it
          </Link>
        </P1>

        <Button
          style={{ marginTop: '3rem' }}
          type="submit"
          onClick={this.onSubmit}
          working={this.state.fetching}
          arrow={true}
        >
          Continue
        </Button>
      </div>
    );
  }
}

export default props => {
  return (
    <Login>
      <LoginForm {...props} />
    </Login>
  );
};



// WEBPACK FOOTER //
// ./src/components/LoginForm/LoginForm.js